import { Box, IconButton, Modal, ModalProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ControlledModaldProps = {
    children: React.ReactNode;
    handleClose?: () => void;
    closeLabel?: string;
    showCloseButton?: boolean;
} & ModalProps;

export default function ModalBase({
    handleClose,
    closeLabel = 'Close',
    showCloseButton = false,
    children,
    ...rest
}: ControlledModaldProps) {
    return (
        <Modal
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            {...rest}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: '8px',
                    boxShadow: 24,
                    p: 4,
                    width: '80%',
                    maxWidth: 1000,
                    '&:focus-visible': {
                        outline: 'none',
                    },
                }}
            >
                {showCloseButton && handleClose && (
                    <IconButton
                        aria-label={closeLabel}
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                {children}
            </Box>
        </Modal>
    );
}
